module.exports = __webpack_public_path__ + "static/home-trim-94edb6f5c04710f6c32773fe2e27a683.mp4";